import './App.css';
import React, { useRef } from "react";

import Companies from './components/Companies/Companies';
import Contact from './components/contact/Contact';
import Extra from './components/Extra/Extra';
import Footer from './components/Footer/Footer';
import Getstarted from './components/Getstarted/Getstarted';
import Header from "./components/Header/Header"
import Recedencies from './components/Recedencies/Recedencies';
import Value from './components/value/Value';


function App() {

  const valueRef = useRef(null);
  const recedencyRef = useRef(null);
  const startedRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToValueSection = () => {
    valueRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollTorecedencySection = () => {
    recedencyRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollTocontactSection = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  const scrollTostartedSection = () => {
    startedRef.current?.scrollIntoView({ behavior: "smooth" });
  };


  return (
    <> 
      
    <Header onValueClick={ scrollToValueSection}
    onstartedClick={scrollTostartedSection }
    onrecedencyClick={scrollTorecedencySection }
    oncontactClick={scrollTocontactSection } />
    <Extra/>
    <Companies/>
    <Recedencies refProp={recedencyRef}/>
    <Value  refProp={valueRef} />
    <Contact refProp={contactRef}/>
    <Getstarted refProp={startedRef}/>
    <Footer/>

    </>
    
  )
}

export default App
